<template>
    <div
        class="shadow-outline px-4 py-3 rounded-lg bg-primary bg-opacity-10 w-full flex items-center justify-between relative text-primary"
    >
        <div class="flex items-center space-x-4">
            <icon-svg icon="info" class="w-5" />
            <typography variant="p" class="font-semibold"
                >We're currently encoding this collection...</typography
            >
        </div>

        <div class="loading-spinner">
            <div class="spin-icon"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "IsEncoding",
};
</script>

<style scoped>
.loading-spinner {
    @apply inline relative z-30;
}

.loading-spinner .spin-icon {
    @apply m-auto w-5 h-5 border-2 rounded-full;

    border: solid 3px transparent;
    border-top-color: currentColor;
    border-left-color: currentColor;
    animation: loading-spinner 1000ms linear infinite;
}

@keyframes loading-spinner {
    0% {
        transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
        transform: rotate(360deg);
    }
}
</style>
